import { motion } from 'framer-motion';
import React from 'react';
import './styles.scss';

interface BackdropProps {
	children: React.ReactElement;
	onClick: any;
	className?: string;
}
export const Backdrop: React.FC<BackdropProps> = ({ children, onClick, className }) => {
	return (
		<motion.section
			className={'backdrop ' + (className ? className : '')}
			onClick={onClick}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			{children}
		</motion.section>
	);
};

export default Backdrop;
